import regular from './regular';

export default {
  regular,
};
